import type { FormField, ReactiveDropdownDependencyBehaviour } from '../../interfaces/form.interface';

export type ResolvedReactiveDropdownDependencyBehaviour = ReactiveDropdownDependencyBehaviour & Required<Pick<
  ReactiveDropdownDependencyBehaviour,
  | 'clearOnParentChange'
  | 'keepCurrentValueIfStillAvailable'
  | 'keepValueUntilOptionsLoaded'
  | 'preservePanelOnReload'
  | 'preserveFilterOnReload'
  | 'showLoadingOptionDuringReload'
  | 'reloadOnParentChange'
  | 'filterLocally'
>>;

export const DEFAULT_REACTIVE_DROPDOWN_DEPENDENCY_BEHAVIOUR: ResolvedReactiveDropdownDependencyBehaviour = {
  clearOnParentChange: true,
  keepCurrentValueIfStillAvailable: true,
  keepValueUntilOptionsLoaded: true,
  preservePanelOnReload: true,
  preserveFilterOnReload: true,
  showLoadingOptionDuringReload: true,
  reloadOnParentChange: false,
  filterLocally: true,
};

export function resolveReactiveDropdownDependencyBehaviour<T>(
  field: Pick<FormField<T>, 'dependencyBehaviour'>,
): ResolvedReactiveDropdownDependencyBehaviour {
  return {
    ...DEFAULT_REACTIVE_DROPDOWN_DEPENDENCY_BEHAVIOUR,
    ...field.dependencyBehaviour,
  };
}
